var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const DEPOSIT_STATEMENT_CODE = 'DEPOSIT_WEEKLY_LIMIT_EXCEEDED';
export const DEPOSIT_PROOF_CODE = 'DEPOSIT_WEEKLY_LIMIT_L2_EXCEEDED';
/** The state the window opens in: the statement first, then the proof, then the proof awaiting the review; null when nothing is owed. */
export function depositOriginState(user) {
    if (!user) {
        return null;
    }
    if (user.deposit_origin_statement_required === true) {
        return 'statement';
    }
    if (user.deposit_origin_proof_required === true) {
        return user.deposit_origin_proof_submitted === true ? 'pending' : 'proof';
    }
    return null;
}
/** Whether an API refusal carries a deposit-limit code, which the window answers instead of an error message. */
export function isDepositOriginCode(message) {
    return message === DEPOSIT_STATEMENT_CODE || message === DEPOSIT_PROOF_CODE;
}
/** The state for a refusal: the one the fresh flags show, else the one the code names (L1 the statement, L2 the proof). */
export function depositOriginStateForCode(code, user) {
    const state = depositOriginState(user);
    if (state !== null) {
        return state;
    }
    return code === DEPOSIT_STATEMENT_CODE ? 'statement' : 'proof';
}
/**
 * After the statement is in: the proof when it is owed too, its pending state when a proof is
 * already sent, null when nothing is left (the window closes and the action continues). The
 * statement flag is not read: the refreshed user/data may not have come back.
 */
export function depositOriginStateAfterStatement(user) {
    return user ? depositOriginState(Object.assign(Object.assign({}, user), { deposit_origin_statement_required: false })) : null;
}
/** Where a user the trigger asks something of lands after login: the wallet when they have one, the exchange home page otherwise. */
export function depositOriginLoginRoute(user) {
    return user && Number(user.wallet_created) === 1 ? '/wallet/cryptocurrencies' : '/';
}
